window.lazyLoad = window.lazyLoad || {};

angular.module('ffApp').controller('LazyLoadController', ['$scope', function($scope)
{
	$scope.thresholdElement = null;
	$scope.offset = 0;
	$scope.loaderTriggered = false;

	if( typeof window.lazyLoad.scrollBound == "undefined" || window.lazyLoad.scrollBound == false ) {
		jQuery(window).bind("scroll", function(){
			$scope.update();
		});
		window.lazyLoad.scrollBound = true;
	}

	if( typeof window.lazyLoad.pageLoadSuccessBound == "undefined" || window.lazyLoad.pageLoadSuccessBound == false ) {
		jQuery(window).on('ngPageLoadSuccess', function(){
			$scope.thresholdElement = null;
			$scope.loaderTriggered = false;
			window.lazyLoad.scrollBound = false;
		});
		window.lazyLoad.pageLoadSuccessBound = true;
	}

	$scope.update = function()
	{
		if( typeof $scope.thresholdElement != "undefined" && $scope.thresholdElement != null && $scope.thresholdElement.length > 0 ) {
			if( $scope.inView( $scope.thresholdElement ) ) {
				if( $scope.loaderTriggered == false ) {
					$scope.$broadcast( 'loadPosts', $scope.offset );
					$scope.loaderTriggered = true;
				}
			}
		}
		else {
			$scope.$broadcast( 'queryThresholdElement' );
		}

	}

	//Inview function adapted from jquery.unveil
	$scope.inView = function( el )
	{
		var th = 10; //Threshold in pixels
		var $w = jQuery(window);
		var $e = jQuery(el);
		if ($e == null || $e.is(":hidden")) {
			return;
		}

		var wt = $w.scrollTop(),
			wb = wt + $w.height(),
			et = $e.offset().top,
			eb = et + $e.height();

		return eb >= wt - th && et <= wb + th;
	};
	$scope.insertLoaderHTML = function( parent, string, classes )
	{
		var html = "<div class='loader "+classes+"'><div></div><span>"+string+"</span></div>";
		jQuery(parent).append(html);
	};
	$scope.removeLoaderHTML = function( parent )
	{
		jQuery( parent ).find('.loader').remove();
	};


}]);